import { render, staticRenderFns } from "./form.vue?vue&type=template&id=1b1c8d38&scoped=true&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"
import style0 from "./form.vue?vue&type=style&index=0&id=1b1c8d38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1c8d38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/kivateknoloji/kivacloud/corona-ux/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b1c8d38')) {
      api.createRecord('1b1c8d38', component.options)
    } else {
      api.reload('1b1c8d38', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=1b1c8d38&scoped=true&", function () {
      api.rerender('1b1c8d38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/crm/components/account/form.vue"
export default component.exports